const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalFilesBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-105"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "164.43 71.18 134.75 273.01 365.25 273.01 335.57 71.18",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.88,91.41l-1.1,5.46-11.3,56.19a3.7,3.7,0,0,1-3.63,3H199.15a3.7,3.7,0,0,1-3.63-3L184,95.54l-.83-4.13A1.9,1.9,0,0,1,185,89.14H315A1.9,1.9,0,0,1,316.88,91.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.48,106.15l-1.1,5.34-11.59,56.13a3.77,3.77,0,0,1-3.72,3H197.93a3.77,3.77,0,0,1-3.72-3L182.58,111.3l-1.06-5.15a1.91,1.91,0,0,1,1.9-2.27H316.58A1.91,1.91,0,0,1,318.48,106.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.25,142.12H178.75a1.94,1.94,0,0,0-2,2.24l3.34,15,10.24,45.93a4,4,0,0,0,4,2.94H305.73a4,4,0,0,0,4-2.94l5-22.53,8.56-38.39A1.94,1.94,0,0,0,321.25,142.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.4,211.67,327,218.85l-10.57,53.63a4.29,4.29,0,0,1-4.19,3.1l-121.07,5.56a4.29,4.29,0,0,1-4.46-2.7L170,221.74l-.81-2.75c-.33-1.13.69-2.25,2.11-2.31l154.81-7.12C327.52,209.5,328.63,210.52,328.4,211.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.56,236.32l-3,9.88-15.14,49.26a4.36,4.36,0,0,1-4.56,2.66l-123.47-6.45a4.38,4.38,0,0,1-4.26-3.12l-10.45-53.27-1.46-7.45c-.23-1.15.92-2.16,2.37-2.08L330.42,234C331.87,234.08,332.91,235.2,332.56,236.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-105"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "340.37 392.97 159.63 392.97 120.07 280.78 379.93 280.78 340.37 392.97",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.63,123.53l-.82-2.35a3.93,3.93,0,0,0-3.26-2.46l-22.24-2.87a2.13,2.13,0,0,0-2.49,1.68l-.29,2.25-17.72-2.28a2,2,0,0,0-2.41,2l6.31,65.14,120,15.47,22.62-61.41a2,2,0,0,0-1.82-2.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.48,142.39,336,198l-1.58,4.28a4.15,4.15,0,0,1-4.51,2.44L214.26,189.8a4.15,4.15,0,0,1-3.74-3.51l-6.15-63.5a2,2,0,0,1,2.41-2l98.42,12.69,49.46,6.37A2,2,0,0,1,356.48,142.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.06,44.14s46.72-9.47,89.23,0c26,5.79,80.75,19.52,93.68,50.64s-49.3,57.67-18.73,89.24c13.19,13.62,76.48,31.58,72.92,119.92S345.87,446.13,217,443.73,13.73,324.14,63.57,266.43s71.3-57.88,48.71-104.88S121.05,57.59,205.06,44.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.06,44.14s46.72-9.47,89.23,0c26,5.79,80.75,19.52,93.68,50.64s-49.3,57.67-18.73,89.24c13.19,13.62,76.48,31.58,72.92,119.92S345.87,446.13,217,443.73,13.73,324.14,63.57,266.43s71.3-57.88,48.71-104.88S121.05,57.59,205.06,44.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-105"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.94 188.19 124.64 213.63 82.92 227.9 72.6 197.71 114.32 183.44 115.94 188.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.28 200.86 124.64 213.63 82.92 227.9 80.78 221.64 89.19 208.9 102.88 214.23 112.65 197.75 120.28 200.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22,199.25a4.54,4.54,0,1,1-5.76-2.82A4.53,4.53,0,0,1,94.22,199.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.56 397 358.81 423.27 315.74 413.83 322.56 382.67 365.64 392.1 364.56 397",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.28,
    y1: 407.11,
    x2: 353.87,
    y2: 413.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.7,393.3s-3,13.75,12.36,17.12S357.43,400,357.43,400",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,393.59a1.34,1.34,0,0,1-1.58,1,1.33,1.33,0,1,1,1.58-1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.73,400.32a1.33,1.33,0,1,1-2.59-.57,1.33,1.33,0,0,1,2.59.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 405.89,
    width: 2.33,
    height: 2.33,
    transform: "translate(94.57 -59.82) rotate(12.35)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.89,
    y: 409.25,
    width: 2.33,
    height: 2.33,
    transform: "translate(95.64 -63.03) rotate(12.35)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.26,
    y: 412.62,
    width: 2.33,
    height: 2.33,
    transform: "translate(96.72 -66.24) rotate(12.35)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.25 111.27 154.37 135.86 114.04 118 126.96 88.83 167.28 106.68 165.25 111.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,121.41c-.77,1.74-3.56,2.2-6.22,1s-4.19-3.55-3.42-5.3,3.56-2.2,6.22-1S144.85,119.66,144.08,121.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,102.2l-10.76,15.35-.92-.41,7.87-11.22,2-2.92a6.14,6.14,0,0,0,1.76-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,102.21l-2.61,3.7a5.65,5.65,0,0,1-1.19,0,8.56,8.56,0,0,1-3.37-1,4.26,4.26,0,0,0-4.53.31c.13-.16,2.67-3.33,6.17-2.22a6.26,6.26,0,0,0,3.77,0A6.14,6.14,0,0,0,146.11,102.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.03 310.61 424.64 335.81 383.32 320.42 394.46 290.51 435.78 305.91 434.03 310.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "406.22 305.07 395.86 309.81 400.6 320.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "411.73 324.32 422.1 319.59 417.36 309.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.6,
    y1: 307.8,
    x2: 404.35,
    y2: 321.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.8 76.47 383.59 101.74 342.16 86.63 353.09 56.65 394.52 71.76 392.8 76.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.45,78.37s-.5-2.83-4.68-2.21c-3.86.58-5,4.92-1.7,6.11,3.83,1.4,6.83-1.84,10.56-5,3.89-3.33,7.42-6.92,7.87-7.34,0,0-8.77,15.69-9.91,17.76s2.29,1.31,2.91.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,83a5.18,5.18,0,0,0-7,1.18c-1.22,1.47-.58,3,.47,3.41,2.7,1,4.37-.2,7.21-4.33,0,0-3.93,5.52-3.09,5.83a2.17,2.17,0,0,0,2.19-.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.44,
    y1: 78.73,
    x2: 373.38,
    y2: 81.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.36 368.44 76.28 359.02 82.16 332.14 125.38 341.6 119.36 368.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.92,
    y1: 338.87,
    x2: 117.1,
    y2: 344.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.85,
    y1: 340.51,
    x2: 116.57,
    y2: 346.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.32,
    y1: 342.93,
    x2: 116.04,
    y2: 349.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.79,
    y1: 345.35,
    x2: 115.51,
    y2: 351.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.26,
    y1: 347.76,
    x2: 114.98,
    y2: 354.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.74,
    y1: 350.18,
    x2: 114.46,
    y2: 356.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.21,
    y1: 352.59,
    x2: 113.93,
    y2: 358.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.68,
    y1: 355.01,
    x2: 109.86,
    y2: 360.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawer--inject-105"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.58 167.97 169.42 167.97 149.31 67.93 350.69 67.93 330.58 167.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "164.43 71.18 134.75 273.01 365.25 273.01 335.57 71.18",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "365.25 273.01 134.75 273.01 147.16 188.61 352.84 188.61 365.25 273.01",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "164.43 71.18 134.75 273.01 365.25 273.01 335.57 71.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.3 71.18 170.7 71.18 143.2 273.01 356.8 273.01 329.3 71.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,86.56H227.54l-1-2.2a3.39,3.39,0,0,0-3.1-2H203.92a2,2,0,0,0-2,2v2.24H186.37a1.9,1.9,0,0,0-1.86,2.27l12.72,63.25H302.77l12.72-63.25A1.9,1.9,0,0,0,313.63,86.56Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.88,91.41l-1.1,5.46-11.3,56.19a3.7,3.7,0,0,1-3.63,3H199.15a3.7,3.7,0,0,1-3.63-3L184,95.54l-.83-4.13A1.9,1.9,0,0,1,185,89.14H315A1.9,1.9,0,0,1,316.88,91.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.78,96.87l-11.3,56.19a3.7,3.7,0,0,1-3.63,3H199.15a3.7,3.7,0,0,1-3.63-3L184,95.54Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.88,91.41l-1.1,5.46-11.3,56.19a3.7,3.7,0,0,1-3.63,3H199.15a3.7,3.7,0,0,1-3.63-3L184,95.54l-.83-4.13A1.9,1.9,0,0,1,185,89.14H315A1.9,1.9,0,0,1,316.88,91.41Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.16,101.13H227l-1-2.19a3.48,3.48,0,0,0-3.17-2h-20a2,2,0,0,0-2,2v2.24h-16a1.91,1.91,0,0,0-1.9,2.27l13,63.06H304l13-63.06A1.91,1.91,0,0,0,315.16,101.13Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,106.15l-1.1,5.34-11.59,56.13a3.77,3.77,0,0,1-3.72,3H197.93a3.77,3.77,0,0,1-3.72-3L182.58,111.3l-1.06-5.15a1.91,1.91,0,0,1,1.9-2.27H316.58A1.91,1.91,0,0,1,318.48,106.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.38,111.49l-11.59,56.13a3.77,3.77,0,0,1-3.72,3H197.93a3.77,3.77,0,0,1-3.72-3L182.58,111.3Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,106.15l-1.1,5.34-11.59,56.13a3.77,3.77,0,0,1-3.72,3H197.93a3.77,3.77,0,0,1-3.72-3L182.58,111.3l-1.06-5.15a1.91,1.91,0,0,1,1.9-2.27H316.58A1.91,1.91,0,0,1,318.48,106.15Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.68,115.7H226.47l-1-2.19a3.55,3.55,0,0,0-3.24-2H201.71a2,2,0,0,0-2.06,2v2.23H183.32a1.92,1.92,0,0,0-1.95,2.26l13.33,62.87H305.3L318.63,118A1.92,1.92,0,0,0,316.68,115.7Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,118.63H181.86a1.91,1.91,0,0,0-1.94,2.25l13,61.29a3.83,3.83,0,0,0,3.8,3H303.29a3.83,3.83,0,0,0,3.8-3l13-61.29A1.91,1.91,0,0,0,318.14,118.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.21,127.27H225.93l-1.05-2.18a3.65,3.65,0,0,0-3.31-2h-21a2,2,0,0,0-2.11,2v2.23H181.79a1.93,1.93,0,0,0-2,2.25l13.63,62.69H306.57l13.63-62.69A1.93,1.93,0,0,0,318.21,127.27Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.7,130.37H180.3a1.93,1.93,0,0,0-2,2.25l13.29,61.11a3.9,3.9,0,0,0,3.89,2.94h109a3.9,3.9,0,0,0,3.89-2.94l13.29-61.11A1.93,1.93,0,0,0,319.7,130.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.73,138.84H225.39l-1.07-2.18a3.75,3.75,0,0,0-3.39-2H199.5a2.05,2.05,0,0,0-2.15,1.94v2.22H180.27a2,2,0,0,0-2,2.24l13.94,62.5H307.83l13.94-62.5A2,2,0,0,0,319.73,138.84Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,142.12H178.75a1.94,1.94,0,0,0-2,2.24l3.34,15,10.24,45.93a4,4,0,0,0,4,2.94H305.73a4,4,0,0,0,4-2.94l5-22.53,8.56-38.39A1.94,1.94,0,0,0,321.25,142.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.05,159.35l10.24,45.93a4,4,0,0,0,4,2.94H305.73a4,4,0,0,0,4-2.94l5-22.53Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,142.12H178.75a1.94,1.94,0,0,0-2,2.24l3.34,15,10.24,45.93a4,4,0,0,0,4,2.94H305.73a4,4,0,0,0,4-2.94l5-22.53,8.56-38.39A1.94,1.94,0,0,0,321.25,142.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.77,210.39l-1.26-2.1a4.15,4.15,0,0,0-3.77-1.8l-23.28,1.07a2.17,2.17,0,0,0-2.25,2l.1,2.2-18.56.85c-1.42.06-2.44,1.18-2.1,2.31l18,61,125.64-5.78,12.31-62.37c.22-1.16-.89-2.18-2.32-2.11Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,211.67,327,218.85l-10.57,53.63a4.29,4.29,0,0,1-4.19,3.1l-121.07,5.56a4.29,4.29,0,0,1-4.46-2.7L170,221.74l-.81-2.75c-.33-1.13.69-2.25,2.11-2.31l154.81-7.12C327.52,209.5,328.63,210.52,328.4,211.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327,218.85l-10.57,53.63a4.29,4.29,0,0,1-4.19,3.1l-121.07,5.56a4.29,4.29,0,0,1-4.46-2.7L170,221.74Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,211.67,327,218.85l-10.57,53.63a4.29,4.29,0,0,1-4.19,3.1l-121.07,5.56a4.29,4.29,0,0,1-4.46-2.7L170,221.74l-.81-2.75c-.33-1.13.69-2.25,2.11-2.31l154.81-7.12C327.52,209.5,328.63,210.52,328.4,211.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.44,224.31l-1.07-2.2a4.27,4.27,0,0,0-3.66-2.16L196,218.71a2.2,2.2,0,0,0-2.5,1.79l-.11,2.19-18.92-1c-1.45-.08-2.59.93-2.37,2.08l12.23,62.29,128.13,6.7,18.65-60.67c.34-1.13-.69-2.25-2.14-2.32Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.56,236.32l-3,9.88-15.14,49.26a4.36,4.36,0,0,1-4.56,2.66l-123.47-6.45a4.38,4.38,0,0,1-4.26-3.12l-10.45-53.27-1.46-7.45c-.23-1.15.92-2.16,2.37-2.08L330.42,234C331.87,234.08,332.91,235.2,332.56,236.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.52,246.2l-15.14,49.26a4.36,4.36,0,0,1-4.56,2.66l-123.47-6.45a4.38,4.38,0,0,1-4.26-3.12l-10.45-53.27Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.56,236.32l-3,9.88-15.14,49.26a4.36,4.36,0,0,1-4.56,2.66l-123.47-6.45a4.38,4.38,0,0,1-4.26-3.12l-10.45-53.27-1.46-7.45c-.23-1.15.92-2.16,2.37-2.08L330.42,234C331.87,234.08,332.91,235.2,332.56,236.32Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16,240.26,221,238.12a4.37,4.37,0,0,0-3.83-2H192.88a2.22,2.22,0,0,0-2.44,1.91v2.18H171.12c-1.48,0-2.59,1.06-2.3,2.2l15.76,61.37H315.42l15.76-61.37c.29-1.14-.82-2.2-2.3-2.2Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,309.49H187c-2.18,0-4.07-1.21-4.5-2.88L167.1,246.78c-.3-1.14.81-2.2,2.3-2.2H330.6c1.49,0,2.6,1.06,2.3,2.2l-15.36,59.83C317.11,308.28,315.22,309.49,313,309.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,254.83l-1.23-2.13a4.49,4.49,0,0,0-3.91-1.95h-24.7a2.25,2.25,0,0,0-2.49,1.91v2.17H169.6c-1.52,0-2.65,1.06-2.35,2.2l16.07,61.18H316.68L332.75,257c.3-1.14-.83-2.2-2.35-2.2Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.26,324H185.74c-2.22,0-4.14-1.21-4.58-2.88l-15.67-59.64c-.29-1.14.84-2.2,2.35-2.2H332.16c1.51,0,2.64,1.06,2.35,2.2l-15.67,59.64C318.4,322.83,316.48,324,314.26,324Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.37 392.97 159.63 392.97 120.07 280.78 379.93 280.78 340.37 392.97",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "340.37 392.97 159.63 392.97 120.07 280.78 379.93 280.78 340.37 392.97",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "340.37 392.97 159.63 392.97 120.07 280.78 379.93 280.78 340.37 392.97",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.49 266.01 123.51 266.01 120.07 280.78 379.93 280.78 376.49 266.01",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.27 332.18 184.74 356.13 315.26 356.13 312.73 332.18 306.97 332.18 308.61 349.27 191.39 349.27 193.03 332.18 187.27 332.18",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.28 361.63 185.72 361.63 184.74 356.13 315.26 356.13 314.28 361.63",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.97 332.18 306.17 338.53 306.97 349.27 308.61 349.27 306.97 332.18",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.03 332.18 193.84 338.53 193.03 349.27 191.39 349.27 193.03 332.18",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.06 320.16 207.94 320.16 203.93 299.84 296.07 299.84 292.06 320.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,312.94h0l.56-8.61h2.56l.75,11.95h-1.65l-.59-8.44h0l-.57,8.44h-1.66l-2-8.32h0l.75,8.32H229l-1.16-11.95h2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,312.46l-2.73-8.13h1.93l1.64,5.6h0l1.13-5.6h1.76l-2,8.13.16,3.82h-1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,309.8h2.33v1.7h-2.3l0,4.78h-1.75l-.2-11.95H251v1.79h-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,304.33h1.84l-.19,11.95h-1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.11,304.33H257l-.31,10.32h2.89l-.07,1.63h-4.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35,309.52h2.47l-.11,1.71h-2.46l-.19,3.42h3l-.11,1.63h-4.76l.56-11.95h5l-.13,1.79h-3.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.45,304.19c1.8,0,2.61,1.14,2.42,3.13l0,.38h-1.72l.05-.51c.08-.88-.23-1.22-.81-1.22s-.94.34-1,1.22.23,1.55,1.32,2.64c1.37,1.38,1.75,2.36,1.62,3.69-.18,1.85-1.17,2.89-2.88,2.89s-2.53-1-2.4-2.89l.06-.71h1.68l-.07.83c-.07.83.26,1.12.82,1.12s.94-.29,1-1.12-.22-1.48-1.3-2.55c-1.39-1.38-1.8-2.38-1.69-3.77C266.65,305.33,267.66,304.19,269.45,304.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.63,123.53l-.82-2.35a3.93,3.93,0,0,0-3.26-2.46l-22.24-2.87a2.13,2.13,0,0,0-2.49,1.68l-.29,2.25-17.72-2.28a2,2,0,0,0-2.41,2l6.31,65.14,120,15.47,22.62-61.41a2,2,0,0,0-1.82-2.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.63,123.53l-.82-2.35a3.93,3.93,0,0,0-3.26-2.46l-22.24-2.87a2.13,2.13,0,0,0-2.49,1.68l-.29,2.25-17.72-2.28a2,2,0,0,0-2.41,2l6.31,65.14,120,15.47,22.62-61.41a2,2,0,0,0-1.82-2.54Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.63,123.53l-.82-2.35a3.93,3.93,0,0,0-3.26-2.46l-22.24-2.87a2.13,2.13,0,0,0-2.49,1.68l-.29,2.25-17.72-2.28a2,2,0,0,0-2.41,2l6.31,65.14,120,15.47,22.62-61.41a2,2,0,0,0-1.82-2.54Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,142.39,336,198l-1.58,4.28a4.15,4.15,0,0,1-4.51,2.44L214.26,189.8a4.15,4.15,0,0,1-3.74-3.51l-6.15-63.5a2,2,0,0,1,2.41-2l98.42,12.69,49.46,6.37A2,2,0,0,1,356.48,142.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.48,142.39,336,198c-14.51-3.43-15.06-12.47-17.49-17.15-2.68-5.16-19.67-7.9-24.42-8.73s-7.64-5.64-7.64-5.64c-4.28-12,18.06-22.5,18.06-22.5-.44-1.65.21-7.06.68-10.48l49.46,6.37A2,2,0,0,1,356.48,142.39Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.48,142.39,336,198l-1.58,4.28a4.15,4.15,0,0,1-4.51,2.44L214.26,189.8a4.15,4.15,0,0,1-3.74-3.51l-6.15-63.5a2,2,0,0,1,2.41-2l98.42,12.69,49.46,6.37A2,2,0,0,1,356.48,142.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.12 139.9 227.7 179.2 241.94 181.04 243.62 141.88 226.12 139.9",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.81,176.31a5.1,5.1,0,0,0-.69-4.11,15.25,15.25,0,0,0-2.89-3.17,14.2,14.2,0,0,0,5.37,1.78c0-2.05-2-3.47-3.71-4.55a2.82,2.82,0,0,1,2.42.18,2,2,0,0,0-.71-1.69c.22.19.56-.11.55-.39a1.79,1.79,0,0,0-.35-.77,3.83,3.83,0,0,1-.31-1.93c0-2.35.07-4.71.1-7.06a1.12,1.12,0,0,0,.82.91c0-.93-.11-1.86-.2-2.79-.22-2.35-.44-4.71-.67-7.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,267.68s-80.7-72.2-85.84-76.75-8.9-4.35-11.67-7.12-4.16-4.74-15.43-4.55-26.31-5.93-29.67-8.11-8.11-.59-11.28-1.82-11.27-.15-16.22,0-5.34-4.9-3.36-10.64,17-9.29,19-8.11,9.89-2.17,9.89-2.17c-1.19-4.16-.79-14.25-.79-14.25s-8.31-3.56-11.47-4.74a20.2,20.2,0,0,0-7.52-.79s1-4.54,2.57-6.23,9.1-3.27,16.42-8.41,11.87-6.33,13-5.94,9.3,2.77,11.48,2.77,5.34-2,8.5-1.38,8.9,5.54,11.47,6.13,3.36,1.13,6.73,1.13c1.48,0,7.52,4.41,7.52,4.41a31,31,0,0,1,7.32,2.37c3.75,1.78,7.71,10.29,9.49,13.06s2,9.49,2,9.49,4.75,2.57,6.53,6.13S467,190.93,467,190.93,477.33,231.42,461,267.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.54,216.25c-14.46-12.94-26.46-23.66-28.34-25.32-5.15-4.55-8.9-4.35-11.67-7.12s-4.16-4.74-15.43-4.55-26.31-5.93-29.67-8.11-8.11-.59-11.28-1.82-11.27-.15-16.22,0-5.34-4.9-3.36-10.64,17-9.29,19-8.11,9.89-2.17,9.89-2.17c-1.19-4.16-.79-14.25-.79-14.25s-8.31-3.56-11.47-4.74a20.2,20.2,0,0,0-7.52-.79s1-4.54,2.57-6.23,9.1-3.27,16.42-8.41,11.87-6.33,13-5.94,9.3,2.77,11.48,2.77c1.65,0,3.88-1.14,6.25-1.43-1.92,1.07-3.25,3.11-2.89,4.2.57,1.72,2.18,6.1,2.27,6.38-.43-.42-10.8-10.66-17.5-10.13-5.79.45-11.67,10.2-10.68,17.36s-1.41,7.16-.11,12.5,2.48,12.86.5,15.83-5.93-2.31-5.93-2.31a9.64,9.64,0,0,0-5,8.24c0,5.74,6,6.13,9.54,6.73s16.6,7.75,25.52,8.13l8.92.37s-5.15-7-3-7.36,8.7.28,13,7,7.6,8.21,15.57,11.51C381.32,189.73,393.74,203.14,403.54,216.25Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.06,177.9c-1.21-.57-40-18.85-41.95-21.58s-4.35-3.4-6.53-6.15-9.49-4.53-10.48-8.29-2.18-15.17-4-16.58a33.13,33.13,0,0,0-4.74-2.9l2.94,7.33s-6.7-9.49-8.29-9.75,1.72,6.9,1.43,6.68-7.55-7-13.63-12.14a9.4,9.4,0,0,0,2.31,1c2.58.59,3.36,1.13,6.73,1.13,1.48,0,7.52,4.41,7.52,4.41a31,31,0,0,1,7.32,2.37c3.75,1.78,7.71,10.29,9.49,13.06s2,9.49,2,9.49,4.75,2.57,6.53,6.13C400.78,154.27,424.17,167.48,443.06,177.9Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.09,177.91h0Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,267.68s-80.7-72.2-85.84-76.75-8.9-4.35-11.67-7.12-4.16-4.74-15.43-4.55-26.31-5.93-29.67-8.11-8.11-.59-11.28-1.82-11.27-.15-16.22,0-5.34-4.9-3.36-10.64,17-9.29,19-8.11,9.89-2.17,9.89-2.17c-1.19-4.16-.79-14.25-.79-14.25s-8.31-3.56-11.47-4.74a20.2,20.2,0,0,0-7.52-.79s1-4.54,2.57-6.23,9.1-3.27,16.42-8.41,11.87-6.33,13-5.94,9.3,2.77,11.48,2.77,5.34-2,8.5-1.38,8.9,5.54,11.47,6.13,3.36,1.13,6.73,1.13c1.48,0,7.52,4.41,7.52,4.41a31,31,0,0,1,7.32,2.37c3.75,1.78,7.71,10.29,9.49,13.06s2,9.49,2,9.49,4.75,2.57,6.53,6.13S467,190.93,467,190.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.66,134.16s.92-7.78,0-8.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,115.11s13.46,11.39,14.51,12.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.69,111.28c1.85,1.15,16.77,14.38,21.65,17.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.2,146c-1.45-.85-5.28-2.7-5.67-4.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.45,148.41s.79,3.23,0,4.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,158.63s-1.84,5.14,2.51,8.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.52,109.84a10.05,10.05,0,0,0-2.64,5.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,125.3a9,9,0,0,0,5.14,5.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,181.61A97.81,97.81,0,0,0,352.69,171",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.49,445.31s64.6-42.46,68.55-47.94a42.62,42.62,0,0,1,7.12-8s1.85-15.83,6.6-24,6.59-14.25,8.7-18.47,12.13-7.38,15-9,7.92-4.75,10.82-4.75a16.22,16.22,0,0,1,6.33,1.85s9.76-5,14.24-1.85c0,0,11.08.53,13.71.26s6.6,1.59,6.6,1.59,6.59-4.74,11.07-2.9,6.62,2.63,6.74,5.27-1.11,11.6-1.11,11.6h-2.2s-7.38,9.61-8.17,11.53-5,12.47-5,12.47,5.53-4.22,9-7.38,9.5-9.23,15.83-10.81,10.81,1.95,10.81,5.72c0,0-7.38,5.88-9,7.73s-4.44,6.59-7.62,10S252,396,245.62,402.85s-34,21.62-40.36,23.73c0,0-38.5,26.9-55.38,49.58C149.88,476.16,104,476.43,84.49,445.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.75,420.78c.55.56,2.8.9,6,1a96.83,96.83,0,0,1-10.46,4.84s-25.18,17.59-43.74,36.32c6.39-10.17,18.66-22.86,23.22-25.5,6.35-3.7,18.55-15.64,18.55-15.64S207.92,418.93,209.75,420.78Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.47,365.66a76.27,76.27,0,0,1,8.66-7.33,44.29,44.29,0,0,0-7.84,12.08c-1.22,6.63-12.66,20.3-12.66,20.3,3.69-11.86.52-14.24,1.56-17.67s1.71-11.84,1.71-11.84,2-3.45,4.11-4.24,7.65-14.77,8.68-16.66-6.83-5-8.94-5.23-2.9,3.42-7.12,5.23-9.52,5.13-11.47,7.07-5.34,10.52-5.56,11.05c.15-.6,2.54-10.23,3.16-12.15.52-1.6,5.59-4.55,7.47-5.6-3.12,1.45-4.87-1.3-7.47-3.8-2.79-2.68-6.95-3.53-11.5-2.14s-7.6,4.82-7.62,4.56-6.8-1.45-9-.8-7.28,2.95-7.28,2.95-4.62-2.66-12.21,4.83c-3.17,3.13-13.72,27-12.14,24.14s8.47-11.4,8.9-11.93C175.45,359.6,161.46,391,158.6,393s-3.69,9.08-14,14.89c-9.78,5.51-47.5,29.22-51.24,31.57C111.25,427.57,150,401.58,153,397.37a42.62,42.62,0,0,1,7.12-8s1.85-15.83,6.6-24,6.59-14.25,8.7-18.47,12.13-7.38,15-9,7.92-4.75,10.82-4.75a16.22,16.22,0,0,1,6.33,1.85s9.76-5,14.24-1.85c0,0,11.08.53,13.71.26s6.6,1.59,6.6,1.59,6.59-4.74,11.07-2.9,6.62,2.63,6.74,5.27-1.11,11.6-1.11,11.6h-2.2s-7.38,9.61-8.17,11.53-5,12.47-5,12.47S249,368.82,252.47,365.66Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11,360.57s-7.38,5.88-9,7.73c-.95,1.11-2.36,3.27-4,5.56a43.88,43.88,0,0,0,1.69-8.2,13.59,13.59,0,0,1,6.33-5,12,12,0,0,1,5-.38A1.51,1.51,0,0,1,279.11,360.57Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.49,445.31s64.6-42.46,68.55-47.94a42.62,42.62,0,0,1,7.12-8s1.85-15.83,6.6-24,6.59-14.25,8.7-18.47,12.13-7.38,15-9,7.92-4.75,10.82-4.75a16.22,16.22,0,0,1,6.33,1.85s9.76-5,14.24-1.85c0,0,11.08.53,13.71.26s6.6,1.59,6.6,1.59,6.59-4.74,11.07-2.9,6.62,2.63,6.74,5.27-1.11,11.6-1.11,11.6h-2.2s-7.38,9.61-8.17,11.53-5,12.47-5,12.47,5.53-4.22,9-7.38,9.5-9.23,15.83-10.81,10.81,1.95,10.81,5.72c0,0-7.38,5.88-9,7.73s-4.44,6.59-7.62,10S252,396,245.62,402.85s-34,21.62-40.36,23.73c0,0-38.5,26.9-55.38,49.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.51,373s1.58,7.92-1.59,15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,341.13a32.93,32.93,0,0,0,9-6.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69,349a19.08,19.08,0,0,0,1.72-5.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.88,333.22a13.64,13.64,0,0,0-8.84,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.64,335.07s-7.91,3.69-10.68,3.69-7.26,3.69-7.26,4.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,389.4a54.72,54.72,0,0,0,5.68-11.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.93,343.51s-5,1.31-6.72,5.53-9.63,18.86-9.63,18.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.75,341.13c-1.06,2.51-12.93,24.53-12.93,24.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalFilesBro);
export default __webpack_public_path__ + "static/media/personal-files-bro.e9227209254cb8599505c38a04b9f2ea.svg";
export { ForwardRef as ReactComponent };